import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, Spinner } from "@/components/common/Primitives";
import { Select } from "@/components/common/Field";
import { IssueList } from "@/components/issues/IssueList";
import { IssueFormDialog } from "@/components/issues/IssueFormDialog";
import { cn } from "@/lib/utils";

const FILTERS = [["", "Open"], ["reported", "Reported"], ["acknowledged", "Acknowledged"], ["in_progress", "In Progress"], ["awaiting_part", "Awaiting Part"], ["resolved", "Resolved"], ["all", "All"]];

export default function IssuesPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState("");
  const [priority, setPriority] = useState("");
  const [open, setOpen] = useState(false);
  const load = useCallback(() => {
    const params = {};
    if (status === "") params.open_only = true; else if (status !== "all") params.status = status;
    if (priority) params.priority = priority;
    api.get("/issues", { params }).then((r) => setRows(r.data));
  }, [status, priority]);
  useEffect(() => { load(); }, [load]);
  return (
    <div>
      <PageHeader title="Issues" subtitle="Report → Acknowledge → In progress → Awaiting part → Resolved" testId="issues-header"
        actions={<button onClick={() => setOpen(true)} data-testid="report-issue-btn" className="flex h-10 items-center gap-1.5 rounded-full bg-primary px-4 text-sm font-semibold text-primary-foreground hover:bg-[#0071e3]"><Plus className="h-4 w-4" />Report issue</button>} />
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <div className="flex gap-1 overflow-x-auto rounded-full bg-muted p-1" data-testid="issue-status-filter">
          {FILTERS.map(([k, label]) => <button key={k} onClick={() => setStatus(k)} data-testid={`issue-filter-${k || "open"}`} className={cn("whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium", status === k ? "bg-card text-primary border border-border" : "text-muted-foreground")}>{label}</button>)}
        </div>
        <Select data-testid="issue-priority-filter" className="w-auto" value={priority} onChange={(e) => setPriority(e.target.value)}><option value="">All priorities</option>{["critical", "high", "medium", "low"].map((p) => <option key={p} value={p}>{p}</option>)}</Select>
      </div>
      {!rows ? <Spinner /> : <IssueList issues={rows} />}
      <IssueFormDialog open={open} onClose={() => setOpen(false)} onSaved={(i) => navigate(`/issues/${i.id}`)} />
    </div>
  );
}
